import React, { createContext, useState, useMemo } from 'react';
import { PlanPage } from '@redlink/components/pages';
import { useQuery, getPageProfileQuery } from '@redlink/services';

export const PlanContext = createContext({});

export const PlanProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);

  const {
    loading: getPageProfileIsBusy,
    data: { PageProfile: { id: pageId } = {} },
  } = useQuery(getPageProfileQuery);

  const PlanContextValue = useMemo(
    () => ({
      showPlanDialog: () => setIsVisible(true),
    }),
    []
  );

  if (getPageProfileIsBusy) return <></>;

  return (
    <PlanContext.Provider value={PlanContextValue}>
      {children}
      <PlanPage
        isVisible={isVisible}
        onDismiss={() => setIsVisible(false)}
        pageId={pageId}
      />
    </PlanContext.Provider>
  );
};
